export const GET_EQUIPMENT_REQUEST = "GET_EQUIPMENT_REQUEST";
export const GET_EQUIPMENT_REQUEST_SUCCESS = "GET_EQUIPMENT_REQUEST_SUCCESS";
export const CREATE_EQUIPMENT_REQUEST = "CREATE_EQUIPMENT_REQUEST";
export const CREATE_EQUIPMENT_REQUEST_SUCCESS = "CREATE_EQUIPMENT_REQUEST_SUCCESS";

export const createEquiment = (name : string, siteId) => ({
    type: CREATE_EQUIPMENT_REQUEST,
    payload: {
        name,
        siteId
    }
})


export const getEquipment = () => ({
    type: GET_EQUIPMENT_REQUEST
});